import React from "react";
import { Helmet } from "react-helmet-async";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

// Renders an FAQ accordion and matching FAQPage structured data.
// Pass includeSchema={false} if another FAQPage schema already exists on the page.
export default function FaqList({ faqs, heading = "Frequently Asked Questions", includeSchema = true, testidPrefix = "faq" }) {
  if (!faqs || faqs.length === 0) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(([q, a]) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
  return (
    <section className="container-x py-16">
      {includeSchema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      )}
      {heading && <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">{heading}</h2>}
      <Accordion type="single" collapsible className="mt-8 max-w-3xl">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={i} value={`f-${i}`} data-testid={`${testidPrefix}-item-${i}`}>
            <AccordionTrigger className="text-left font-heading text-lg font-bold">{q}</AccordionTrigger>
            <AccordionContent className="text-base leading-relaxed text-zinc-600">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
